import { render, staticRenderFns } from "./accent.vue?vue&type=template&id=8a4f90e8&scoped=true"
import script from "./accent.vue?vue&type=script&lang=js"
export * from "./accent.vue?vue&type=script&lang=js"
import style0 from "./accent.vue?vue&type=style&index=0&id=8a4f90e8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a4f90e8",
  null
  
)

export default component.exports